"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
exports.__esModule = true;
exports.useSendAmount = exports.useCalculateCountervalueCallback = exports.useDistribution = exports.useCurrencyPortfolio = exports.usePortfolio = exports.useBalanceHistoryWithCountervalue = exports.useCalculateMany = exports.useCalculate = exports.useCountervaluesExport = exports.useCountervaluesState = exports.useCountervaluesPolling = exports.Countervalues = exports.useTrackingPairForAccounts = void 0;
var bignumber_js_1 = require("bignumber.js");
var react_1 = __importStar(require("react"));
var portfolio_1 = require("../portfolio");
var helpers_1 = require("../account/helpers");
var logic_1 = require("./logic");
var useDebounce_1 = require("../hooks/useDebounce");
var CountervaluesPollingContext = (0, react_1.createContext)({
    wipe: function () { },
    poll: function () { },
    start: function () { },
    stop: function () { },
    pending: false,
    error: null
});
var CountervaluesContext = (0, react_1.createContext)(logic_1.initialState);
function trackingPairsHash(a) {
    return a
        .map(function (p) {
        var _a;
        return "".concat(p.from.ticker, ":").concat(p.to.ticker, ":").concat(((_a = p.startDate) === null || _a === void 0 ? void 0 : _a.toISOString().slice(0, 10)) || "");
    })
        .sort()
        .join("|");
}
function useTrackingPairForAccounts(accounts, countervalue) {
    var memo = (0, react_1.useMemo)(function () { return (0, logic_1.inferTrackingPairForAccounts)(accounts, countervalue); }, [accounts, countervalue]);
    var ref = (0, react_1.useRef)(memo);
    if (trackingPairsHash(ref.current) === trackingPairsHash(memo)) {
        return ref.current;
    }
    ref.current = memo;
    return memo;
}
exports.useTrackingPairForAccounts = useTrackingPairForAccounts;
function Countervalues(_a) {
    var children = _a.children, userSettings = _a.userSettings, _b = _a.pollInitDelay, pollInitDelay = _b === void 0 ? 1 * 1000 : _b, _c = _a.autopollInterval, autopollInterval = _c === void 0 ? 120 * 1000 : _c, _d = _a.debounceDelay, debounceDelay = _d === void 0 ? 1000 : _d, savedState = _a.savedState;
    var debouncedUserSettings = (0, useDebounce_1.useDebounce)(userSettings, debounceDelay);
    var _e = __read((0, react_1.useReducer)(fetchReducer, initialFetchState), 2), _f = _e[0], state = _f.state, pending = _f.pending, error = _f.error, dispatch = _e[1];
    // flag used to trigger a loadCountervalues
    var _g = __read((0, react_1.useState)(false), 2), triggerLoad = _g[0], setTriggerLoad = _g[1];
    // trigger poll only when userSettings changes. in a debounced way.
    (0, react_1.useEffect)(function () {
        setTriggerLoad(true);
    }, [debouncedUserSettings]);
    // loadCountervalues logic
    (0, react_1.useEffect)(function () {
        if (pending || !triggerLoad)
            return;
        setTriggerLoad(false);
        dispatch({
            type: "pending"
        });
        (0, logic_1.loadCountervalues)(state, userSettings).then(function (state) {
            dispatch({
                type: "success",
                payload: state
            });
        }, function (error) {
            dispatch({
                type: "error",
                payload: error
            });
        });
    }, [pending, state, userSettings, triggerLoad]);
    // save the state when it changes
    (0, react_1.useEffect)(function () {
        if (!(savedState === null || savedState === void 0 ? void 0 : savedState.status) || !Object.keys(savedState.status).length)
            return;
        dispatch({
            type: "setCounterValueState",
            payload: (0, logic_1.importCountervalues)(savedState, userSettings)
        }); // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [savedState]);
    // manage the auto polling loop and the interface for user land to trigger a reload
    var _h = __read((0, react_1.useState)(true), 2), isPolling = _h[0], setIsPolling = _h[1];
    (0, react_1.useEffect)(function () {
        if (!isPolling)
            return;
        var pollingTimeout;
        function pollingLoop() {
            setTriggerLoad(true);
            pollingTimeout = setTimeout(pollingLoop, autopollInterval);
        }
        pollingTimeout = setTimeout(pollingLoop, pollInitDelay);
        return function () { return clearTimeout(pollingTimeout); };
    }, [autopollInterval, pollInitDelay, isPolling]);
    var polling = (0, react_1.useMemo)(function () { return ({
        wipe: function () {
            dispatch({
                type: "wipe"
            });
        },
        poll: function () { return setTriggerLoad(true); },
        start: function () { return setIsPolling(true); },
        stop: function () { return setIsPolling(false); },
        pending: pending,
        error: error
    }); }, [pending, error]);
    return (react_1["default"].createElement(CountervaluesPollingContext.Provider, { value: polling },
        react_1["default"].createElement(CountervaluesContext.Provider, { value: state }, children)));
}
exports.Countervalues = Countervalues;
var initialFetchState = {
    state: logic_1.initialState,
    pending: false
};
function fetchReducer(state, action) {
    switch (action.type) {
        case "success":
            return {
                state: action.payload,
                pending: false,
                error: undefined
            };
        case "error":
            return __assign(__assign({}, state), { pending: false, error: action.payload });
        case "pending":
            return __assign(__assign({}, state), { pending: true, error: undefined });
        case "wipe":
            return {
                state: logic_1.initialState,
                pending: false,
                error: undefined
            };
        case "setCounterValueState":
            return __assign(__assign({}, state), { state: action.payload });
        default:
            return state;
    }
}
function useCountervaluesPolling() {
    return (0, react_1.useContext)(CountervaluesPollingContext);
}
exports.useCountervaluesPolling = useCountervaluesPolling;
function useCountervaluesState() {
    return (0, react_1.useContext)(CountervaluesContext);
}
exports.useCountervaluesState = useCountervaluesState;
function useCountervaluesExport() {
    var state = (0, react_1.useContext)(CountervaluesContext);
    return (0, react_1.useMemo)(function () { return (0, logic_1.exportCountervalues)(state); }, [state]);
}
exports.useCountervaluesExport = useCountervaluesExport;
function useCalculate(query) {
    var state = useCountervaluesState();
    return (0, logic_1.calculate)(state, query);
}
exports.useCalculate = useCalculate;
function useCalculateMany(dataPoints, query) {
    var state = useCountervaluesState();
    // TODO how to approach perf for this? hash function of the datapoints? responsability on user land?
    return (0, logic_1.calculateMany)(state, dataPoints, query);
}
exports.useCalculateMany = useCalculateMany;
// TODO perf of the useCalculate*, does it even worth worrying?
// TODO move to portfolio module (I couldn't make useCountervaluesState to work there)
function useBalanceHistoryWithCountervalue(_a) {
    var account = _a.account, range = _a.range, to = _a.to;
    var from = (0, helpers_1.getAccountCurrency)(account);
    var state = useCountervaluesState();
    return (0, react_1.useMemo)(function () {
        return (0, portfolio_1.getBalanceHistoryWithCountervalue)(account, range, function (_, value, date) {
            var countervalue = (0, logic_1.calculate)(state, {
                value: value.toNumber(),
                from: from,
                to: to,
                disableRounding: true,
                date: date
            });
            return typeof countervalue === "number"
                ? new bignumber_js_1.BigNumber(countervalue)
                : countervalue;
        });
    }, [account, from, to, range, state]);
}
exports.useBalanceHistoryWithCountervalue = useBalanceHistoryWithCountervalue;
function usePortfolio(_a) {
    var accounts = _a.accounts, range = _a.range, to = _a.to;
    var state = useCountervaluesState();
    return (0, react_1.useMemo)(function () {
        return (0, portfolio_1.getPortfolio)(accounts, range, function (from, value, date) {
            var countervalue = (0, logic_1.calculate)(state, {
                value: value.toNumber(),
                from: from,
                to: to,
                disableRounding: true,
                date: date
            });
            return typeof countervalue === "number"
                ? new bignumber_js_1.BigNumber(countervalue)
                : countervalue;
        });
    }, [accounts, range, state, to]);
}
exports.usePortfolio = usePortfolio;
function useCurrencyPortfolio(_a) {
    var rawAccounts = _a.accounts, range = _a.range, to = _a.to, currency = _a.currency;
    var accounts = (0, helpers_1.flattenAccounts)(rawAccounts).filter(function (a) { return (0, helpers_1.getAccountCurrency)(a) === currency; });
    var state = useCountervaluesState();
    return (0, react_1.useMemo)(function () {
        return (0, portfolio_1.getCurrencyPortfolio)(accounts, range, function (from, value, date) {
            var countervalue = (0, logic_1.calculate)(state, {
                value: value.toNumber(),
                from: from,
                to: to,
                disableRounding: true,
                date: date
            });
            return typeof countervalue === "number"
                ? new bignumber_js_1.BigNumber(countervalue)
                : countervalue;
        });
    }, [accounts, range, state, to]);
}
exports.useCurrencyPortfolio = useCurrencyPortfolio;
function useDistribution(_a) {
    var accounts = _a.accounts, to = _a.to;
    var calc = useCalculateCountervalueCallback({
        to: to
    });
    return (0, react_1.useMemo)(function () {
        return (0, portfolio_1.getAssetsDistribution)(accounts, calc, {
            minShowFirst: 6,
            maxShowFirst: 6,
            showFirstThreshold: 0.95
        });
    }, [accounts, calc]);
}
exports.useDistribution = useDistribution;
function useCalculateCountervalueCallback(_a) {
    var to = _a.to;
    var state = useCountervaluesState();
    return (0, react_1.useCallback)(function (from, value) {
        var countervalue = (0, logic_1.calculate)(state, {
            value: value.toNumber(),
            from: from,
            to: to,
            disableRounding: true
        });
        return typeof countervalue === "number"
            ? new bignumber_js_1.BigNumber(countervalue)
            : countervalue;
    }, [to, state]);
}
exports.useCalculateCountervalueCallback = useCalculateCountervalueCallback;
function useSendAmount(_a) {
    var account = _a.account, fiatCurrency = _a.fiatCurrency, cryptoAmount = _a.cryptoAmount;
    var cryptoCurrency = (0, helpers_1.getAccountCurrency)(account);
    var fiatCountervalue = useCalculate({
        from: cryptoCurrency,
        to: fiatCurrency,
        value: cryptoAmount.toNumber(),
        disableRounding: true
    });
    var fiatAmount = new bignumber_js_1.BigNumber(fiatCountervalue !== null && fiatCountervalue !== void 0 ? fiatCountervalue : 0);
    var fiatUnit = fiatCurrency.units[0];
    var cryptoUnit = (0, helpers_1.getAccountUnit)(account);
    var state = useCountervaluesState();
    var calculateCryptoAmount = (0, react_1.useCallback)(function (fiatAmount) {
        var _a;
        var cryptoAmount = new bignumber_js_1.BigNumber((_a = (0, logic_1.calculate)(state, {
            from: cryptoCurrency,
            to: fiatCurrency,
            value: fiatAmount.toNumber(),
            reverse: true
        })) !== null && _a !== void 0 ? _a : 0);
        return cryptoAmount;
    }, [state, cryptoCurrency, fiatCurrency]);
    return {
        cryptoUnit: cryptoUnit,
        fiatAmount: fiatAmount,
        fiatUnit: fiatUnit,
        calculateCryptoAmount: calculateCryptoAmount
    };
}
exports.useSendAmount = useSendAmount;
//# sourceMappingURL=react.js.map